// Domínio público oficial da plataforma. A URL de validação impressa/exibida
// nos laudos DEVE ser sempre este domínio — nunca window.location.origin
// (que pode ser um preview do Netlify) nem domínios antigos (eidoc.com.br).
export const PUBLIC_DOMAIN = 'laudando.online';
export const PUBLIC_ORIGIN = `https://${PUBLIC_DOMAIN}`;

// URL completa de validação de um laudo (paciente digita a senha).
export const reportValidationUrl = (id) => `${PUBLIC_ORIGIN}/laudo/${id}`;

// Versão para exibição (sem https://), usada no rodapé do documento.
export const reportValidationDisplay = (id) => `${PUBLIC_DOMAIN}/laudo/${id}`;

// Link de conveniência do dono: abre já validado (token na query), em nova guia.
export const reportOwnerOpenUrl = (id, token) =>
  `${PUBLIC_ORIGIN}/laudo/${id}${token ? `?token=${token}` : ''}`;
